import React from 'react';
import { observer } from 'mobx-react';
import './../../scss/common/loader.scss';
import { useStore } from '../../store/storeUtils';
const ProgressBar = observer(({
  show = true,
  text = '',
  progress = 50,
  affectSave = true
}) => {
  const store = useStore();
  store.updateLoaderCount();
  return show ? /*#__PURE__*/React.createElement("div", {
    className: `progress-bar-container loading-count`
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar-text-container"
  }, text), /*#__PURE__*/React.createElement("div", {
    className: "progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar-progress-container",
    style: {
      width: `${progress}%`
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "progress-bar-progress-text-container"
  }, progress, "%")) : null;
});
export default ProgressBar;